/** @jsx jsx */
import { jsx } from '@emotion/react';
import { Link as GatsbyLink } from 'gatsby';
import isAbsoluteUrl from 'is-absolute-url';
import { ensureTrailingSlash } from '../../../scripts/utils/misc';

export const Link = ({ to, ...props }) =>
  isAbsoluteUrl(to) ? (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      href={to}
      {...props}
      css={{ whiteSpace: 'nowrap' }}
      target={props.target ? props.target : '_blank'}
      rel={props.rel ? props.rel : 'noopener noreferrer'}
    >
      {props.children}
    </a>
  ) : (
    <GatsbyLink css={{ cursor: 'pointer', whiteSpace: 'nowrap' }} to={ensureTrailingSlash(to)} {...props}>
      {props.children}
    </GatsbyLink>
  );
